import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, Injector, Input, LOCALE_ID, ViewChild } from '@angular/core';

import { CerFormActiveDisabled, CerFormComponent } from '@form/cer-form.component';
import { CerPromptService } from '@ui/cer-ui-prompt.service';

import { CerFormView } from '../cer-form-view';
import { CerFormDataNavigation } from '../cer-form-navigation.service';

@Component({
  selector: 'cer-form-dialog',
  templateUrl: './cer-form-dialog.component.html',
  styleUrls: ['./cer-form-dialog.component.css']
})

export class CerFormDialogComponent {

  protected view : CerFormView;
  public routerActive: CerFormActiveDisabled = 'disabled';
  public formPersistenceActive: CerFormActiveDisabled = 'disabled';

  public form: CerFormComponent;
  @ViewChild('form', { static: false }) set formContent(content: CerFormComponent) {
    if (content && !this.form) {
      this.form = content;
      //this.adapter.form = this.form;
      //this.form.commmand.subscribe(e => this.adapter.onCommand(e));
    }
  }

  @Input() dataNavigation: CerFormDataNavigation;

  /*
  public viewComponent: CerFormViewComponent;
  @ViewChild('view', { static: false }) set gridContent(viewComponent: CerFormViewComponent) {
    if (viewComponent && !this.viewComponent) {
      this.viewComponent = viewComponent;
      //this.adapter.viewComponent = this.viewComponent;
    }
  }
  */

  constructor(
    private ui: CerPromptService, 
    private injector: Injector, 
    private dialogRef: MatDialogRef<CerFormDialogComponent>, 
    //private appStateService: AppStateService, private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) callerData: any, 
    @Inject(LOCALE_ID) locale: string) {

    /*
    try {
    if (callerData?.formAdapterType) {
      this.createAdapter(callerData.formAdapterType, callerData);
    }
    }
    catch {
      this.close(false);
    }
    */

    dialogRef.backdropClick().subscribe(() => {
      this.close(false);
    });
  }

  /*
  protected createAdapter(formAdapterType: typeof CerFormAdapter, callerData: any) {
    if (formAdapterType) {
      const adapter: CerFormAdapter = new formAdapterType();
      const viewSet = new CerFormViewSet();
      viewSet.adapter = adapter;
      viewSet.routeOptions = adapter.routeOptions;
      adapter.viewSetInit(viewSet);
      viewSet.panes ??= CerFormPanesSettingsUtil.main();
    }
  }
  */

  public close(ok: boolean = true) {
    this.dialogRef.close({ ok: ok });
  }
}
